import { gql } from '@apollo/client'
import { ConferencePromo } from '@fs/zion-rootstech'
import { brightspotConfig } from '../../config'
import { CalendarDetail } from './fragments'

const { defaults } = brightspotConfig.query

export function getCalendarDetail() {
  return gql(`
    ${CalendarDetail}
    query CalendarDetail(
      $id: ID,
      $profileImage_crop: Boolean = false,
      $profileImage_height: Int = ${defaults.imageSize},
      $profileImage_width: Int = ${defaults.imageSize},
      $promoImage_crop: Boolean = false,
      $promoImage_height: Int = ${defaults.imageSize},
      $promoImage_width: Int = ${defaults.imageSize},
      $thumbnailImage_crop: Boolean = false
      $thumbnailImage_height: Int = ${defaults.imageSize},
      $thumbnailImage_width: Int = ${defaults.imageSize}) {
      CalendarDetail(id: $id) {
        ...CalendarDetail
      }
    }
  `)
}

export function getCalendarSearch() {
  return gql(`
    ${ConferencePromo}
    query CalendarSearch(
      $path: String,
      $queryString: String,
      $creator: String,
      $audience: String,
      $category: String,
      $countryTag: String,
      $tag: String,
      $startDate: Long,
      $endDate: Long,
      $profileImage_crop: Boolean = false,
      $profileImage_height: Int = ${defaults.imageSize},
      $profileImage_width: Int = ${defaults.imageSize},
      $promoImage_crop: Boolean = false,
      $promoImage_height: Int = ${defaults.imageSize},
      $promoImage_width: Int = ${defaults.imageSize},
      $thumbnailImage_crop: Boolean = false,
      $thumbnailImage_height: Int = ${defaults.imageSize},
      $thumbnailImage_width: Int = ${defaults.imageSize}
    ) {
      CalendarSearch(
        path: $path,
        queryString: $queryString,
        creator: $creator,
        audience: $audience,
        category: $category,
        countryTag: $countryTag,
        tag: $tag,
        startDate: $startDate,
        endDate: $endDate
      ) {
        results {
          date
          item {
            ...ConferencePromo
          }
        }
      }
    }
  `)
}
